import Base from "@/x/server/base"
class Login extends Base {
  userLogin(data) {
    return this.get("/wx/open_auth", data).then(this._handleResult);
  }
}
export default new Login();